

<script>
  import { stringifyStyle, calcPxNum, calcBorder } from './utils'
  import Row from './row.svelte'
  import Button from './button.svelte'

  export let value = 0
  export let minValue = 0
  export let maxValue = 10
  export let stepValue = 1

  export let border = 1
  export let borderColor = 'darkgray'
  export let borderRadius = undefined
  export let width = '2rem'
  export let height = '1.4rem'
  export let fontSize = '1rem'
  export let bold = false

  $: inputStyle = {
    'border': calcBorder(border, borderColor),
    'border-radius': calcPxNum(borderRadius),
    'width': calcPxNum(width),
    'height': calcPxNum(height),
    'font-size': calcPxNum(fontSize),
    'text-align': 'center',
    'font-weight': bold ? 'bold' : 'normal',
  }

</script>

<style>
  input:focus {
    outline: none;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>

<Row>
  <Button 
    {border} {borderColor} {fontSize} {height} width={height} lineHeight={`calc(${height} - 0.1rem)`} rightBorder=0
    on:click={()=>{if(value>parseInt(minValue))value=parseInt(value)-parseInt(stepValue)}}
  >-</Button>
  <input 
    type=number
    min={minValue}
    max={maxValue}
    step={stepValue}
    style={stringifyStyle(inputStyle)}
    readonly=true
    bind:value={value} 
    on:input
  />
  <Button 
    {border} {borderColor} {fontSize} {height} width={height} lineHeight={height} leftBorder=0
    on:click={()=>{if(value<parseInt(maxValue))value=parseInt(value)+parseInt(stepValue)}}
  >+</Button>
  
</Row>


